/**
 * Teknik filtresi eşleşme modları.
 * Siparişler ve Maliyet Raporu ekranları aynı mantığı kullanır.
 */
export type TechnicMatchMode = "exact" | "all" | "any";

export const TECHNIC_MATCH_MODES: {
  value: TechnicMatchMode;
  label: string;
  hint: string;
}[] = [
  {
    value: "exact",
    label: "Tam Eşleşme",
    hint: "Sipariş tam olarak seçilen tekniklere sahip olmalı (fazlası/eksiği olmamalı)",
  },
  {
    value: "all",
    label: "Hepsini İçeren",
    hint: "Sipariş seçilen tekniklerin tamamını içermeli, ek teknikleri olabilir",
  },
  {
    value: "any",
    label: "Herhangi Biri",
    hint: "Sipariş seçilen tekniklerden en az birini içermeli",
  },
];

export const getTechnicMatchHint = (mode: TechnicMatchMode): string =>
  TECHNIC_MATCH_MODES.find((m) => m.value === mode)?.hint || "";

/**
 * Bir siparişin teknikleri, seçilen tekniklerle verilen moda göre eşleşiyor mu?
 *   exact : sipariş tam olarak seçilen tekniklere sahip (fazlası/eksiği yok)
 *   all   : sipariş seçilenlerin tamamını içeriyor (ek teknikleri olabilir)
 *   any   : sipariş seçilenlerden en az birini içeriyor
 */
export const matchesTechnicFilter = (
  orderTechnicNames: string[],
  selectedTechnicNames: string[],
  mode: TechnicMatchMode,
): boolean => {
  if (selectedTechnicNames.length === 0) return true;

  if (mode === "any") {
    return selectedTechnicNames.some((name) =>
      orderTechnicNames.includes(name),
    );
  }

  const containsAll = selectedTechnicNames.every((name) =>
    orderTechnicNames.includes(name),
  );

  if (mode === "all") return containsAll;

  // exact: aynı sayıda ve aynı teknikler olmalı
  if (orderTechnicNames.length !== selectedTechnicNames.length) return false;

  return (
    containsAll &&
    orderTechnicNames.every((name) => selectedTechnicNames.includes(name))
  );
};
